import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App.js';
import { getLoyaltyJoinRoute } from './loyaltyJoin.js';
import { LoyaltyJoinView } from './views/LoyaltyJoinView.js';
import { getBookingWidgetRoute } from './bookingWidget.js';
import { BookingWidgetView } from './views/BookingWidgetView.js';
import './i18n.js';
import './styles.css';
import './ui/ui.css';

const loyaltyJoinRoute = getLoyaltyJoinRoute();
const bookingWidgetRoute = getBookingWidgetRoute();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {bookingWidgetRoute ? (
      <BookingWidgetView token={bookingWidgetRoute.token} />
    ) : loyaltyJoinRoute ? (
      <LoyaltyJoinView clientId={loyaltyJoinRoute.clientId} linkSlug={loyaltyJoinRoute.linkSlug} />
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
